// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"2ffdecd7","833":"4b6fe1c9"}[chunkId] + ".chunk.js";
};